var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-icon',{staticClass:"shield",attrs:{"size":"27"}},[_vm._v("$vuetify.icons.ic_security-shield")]),_c('div',[_vm._v(_vm._s(_vm.$t("room_welcome.no_past_messages")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }